import React from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from '../components/ui/Navigation';
import { AnimatePresence, motion } from 'framer-motion';

// Shell for authenticated pages: top navigation plus animated outlet
const AppLayout: React.FC = () => {
    return (
        <div className="min-h-screen bg-william-50 dark:bg-gray-900 transition-colors duration-200">
            <Navigation />
            <main className="pt-6 pb-12 container mx-auto px-4">
                <AnimatePresence mode="wait">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.3 }}
                    >
                        <Outlet />
                    </motion.div>
                </AnimatePresence>
            </main>
        </div>
    );
};

export default AppLayout;
